"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToDomainAdvertisingMachine = mapToDomainAdvertisingMachine;
exports.mapToDomainAdvertisingMachineList = mapToDomainAdvertisingMachineList;
const MachineStatus_1 = require("../../enums/MachineStatus");
function mapToMachineStatus(status) {
    return status?.toUpperCase() === MachineStatus_1.MachineStatus.Online
        ? MachineStatus_1.MachineStatus.Online
        : MachineStatus_1.MachineStatus.Offline;
}
function mapToDomainAdvertisingMachine(dto) {
    return {
        id: dto.id,
        code: dto.code,
        name: dto.name,
        siteId: dto.siteId,
        siteName: dto.siteName,
        status: mapToMachineStatus(dto.status),
        advertisingEnabled: dto.advertisingEnabled ?? false,
        adsCount: dto.adsCount ?? 0,
    };
}
function mapToDomainAdvertisingSummary(dto) {
    return {
        costPerMachine: dto?.costPerMachine ?? 0,
        enabledMachines: dto?.enabledMachines ?? 0,
        estimatedCost: dto?.estimatedCost ?? 0,
    };
}
function mapToDomainAdvertisingMachineList(dto) {
    return {
        machines: (dto.machines ?? []).map(mapToDomainAdvertisingMachine),
        summary: mapToDomainAdvertisingSummary(dto.summary),
    };
}
